/**
 * 按钮权限控制
 */
import type { DirectiveBinding } from 'vue'
import { useUserStore } from '@/store'

function checkPermission(el: HTMLElement, binding: DirectiveBinding) {
  const { value } = binding
  const userStore = useUserStore()
  // console.log('role', userStore.role, el)

  if (Array.isArray(value)) {
    if (value.length > 0) {
      const permissionValues = value
      // 主角色
      const hasPermission = permissionValues.includes(userStore.role)
      if (hasPermission) {
        // el.remove()
        el.style.display = 'block'
      } else {
        el.style.display = 'none'
      }
    }
  } else {
    throw new Error('need roles! Like v-permission="[\'admin\',\'user\']"')
  }
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  }
}
